import { render, staticRenderFns } from "./ConfirmationLogout.vue?vue&type=template&id=f3aa4572&scoped=true"
import script from "./ConfirmationLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmationLogout.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationLogout.vue?vue&type=style&index=0&id=f3aa4572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa4572",
  null
  
)

export default component.exports